import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const PageLoadingSpinner = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  grow: true,
  minHeight: 500
});
export default PageLoadingSpinner;